import { create } from 'zustand';
import { createAgentsSlice } from './slices/agentsSlice';
import { createApprovalsSlice } from './slices/approvalsSlice';
import { createChannelsSlice } from './slices/channelsSlice';
import { createConsoleSlice } from './slices/consoleSlice';
import { createRealtimeSlice } from './slices/realtimeSlice';
import { createSessionSlice } from './slices/sessionSlice';
import { createSettingsSlice } from './slices/settingsSlice';
import { createUiSlice } from './slices/uiSlice';

const useAppStore = create((set, get) => ({
  ...createAgentsSlice(set),
  ...createApprovalsSlice(set),
  ...createChannelsSlice(set),
  ...createConsoleSlice(set),
  ...createSessionSlice(set),
  ...createSettingsSlice(set, get),
  ...createUiSlice(set),
  ...createRealtimeSlice(set)
}));

export default useAppStore;
